export default function Notifications () {
    const notifications = document.querySelectorAll('.site-notification');
    if (!notifications || !notifications.length) return;

    [...notifications].forEach((notification) => {
        const close = notification.querySelector('.site-notification--close');

        if (close) close.addEventListener('click', () => notification.classList.add('hidden'));
    });
}